import moment from 'moment';

moment.locale('nb');
/**
 * Converts a DateTime string to a human-readable
 * time difference from the current date.
 *
 * Goes down to seconds in precision.
 *
 * Note. This converts to norwegian values
 *
 * @param {string|null|undefined} time The time to compare
 * @param {number} compare The base time to compare with
 * @return {string}
 * */
// eslint-disable-next-line import/prefer-default-export
export function humanTimeDiff(time, compare) {
  const fallbackTime = moment().subtract(1, 'minute').fromNow(true);

  // Prevents function from returning '48 år' or other strange values
  if (time === undefined || time === null) {
    return '0 sekund';
  }

  const diffSeconds = Math.floor((compare - new Date(time)) / 1000);

  // Have the lowest shown time be 1 minute
  if (diffSeconds < 60) {
    return fallbackTime;
  }

  return moment(time).from(
    moment(compare),
    // Hide suffix from string
    true,
  );
}

/**
 * Converts a date object to a human readable date
 * @param {Date} dateString
 * @return {string}
 * */
export function toHumanReadableDate(dateString) {
  return moment(dateString).format('DD. MMM YYYY');
}
